import { useState } from "react";
import { FaCheck, FaRegCopy } from "react-icons/fa";

const GeneratedPasswordModal = ({ isOpen, password, onClose }) => {
  const [copied, setCopied] = useState(false);

  if (!isOpen) return null;

  const copyPassword = async () => {
    if (!password) return;
    try {
      await navigator.clipboard.writeText(password);
      setCopied(true);
      setTimeout(() => setCopied(false), 1500);
    } catch (e) {
      setCopied(false);
    }
  };

  return (
    <div className="fixed inset-0 z-50 bg-black/40 flex items-center justify-center p-3 sm:p-4">
      <div className="bg-white w-full max-w-[400px] p-4 sm:p-6 rounded shadow-lg">
        <h3 className="text-lg font-semibold mb-4">
          One Time Password
        </h3>

        <p className="text-sm mb-3">
          The generated one time password
        </p>

        <div className="bg-yellow-300 p-3 rounded font-mono flex items-center justify-between gap-2">
          <span className="break-all">{password}</span>
          <button
            onClick={copyPassword}
            type="button"
            title="Copy password"
            className="shrink-0 p-1.5 rounded bg-yellow-400 hover:bg-yellow-500 transition-colors"
          >
            {copied ? <FaCheck className="text-green-700" /> : <FaRegCopy />}
          </button>
        </div>
        {copied ? <p className="text-xs text-green-700 mt-2">Copied</p> : null}

        <div className="flex justify-end mt-4">
          <button onClick={onClose} className="w-full sm:w-auto text-red-600">
            Close
          </button>
        </div>
      </div>
    </div>
  );
};

export default GeneratedPasswordModal;
